import React, { useRef, useEffect } from "react";

const VerifyCouponRedemptionInput = ({ value, onChange, error }) => {
  const inputRef = useRef(null);

  const handleFocus = () => {
    // ถ้าจะ clear error ต้องให้ parent ส่ง callback เช่น onFocusClearError
  };

  const handleInput = (e) => {
    const raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    const trimmed = raw.slice(0, 4);

    onChange(trimmed);

    if (trimmed.length === 4) {
      inputRef.current?.blur();
    }
  };

  useEffect(() => {
    if (value?.length > 4) {
      onChange(value.slice(0, 4));
    }
  }, [value, onChange]);

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        onChange={handleInput}
        onFocus={handleFocus}
        onClick={handleFocus}
        ref={inputRef}
        maxLength={4}
        className={`
          w-full h-16 text-2xl font-medium text-center
          rounded-lg border tracking-[1.75rem]
          ${error ? "border-danger" : "border-secondary-border focus:border-primary focus:border-2"}
        `}
        style={{ textTransform: "uppercase" }}
      />

      {/* Optional: Error shown inside component */}
      {error && (
        <div className="absolute -bottom-6 left-0 text-sm text-danger">
          {error}
        </div>
      )}
    </div>
  );
};

export default VerifyCouponRedemptionInput;
